module.exports = __webpack_public_path__ + "static/media/clock.18473bd5.svg";